import BrowserDetect from '../../browserDetect';
import BrowserLocation from '../../browserLocation';

const DefautValue = (function () {
  function selectAutomatically(options, internalTitle) {
    let value;
    value = options && options.value && options.value.length ? options.value : '';
    if (options && {}.hasOwnProperty.call(options, 'select_automatically')) {
      switch (internalTitle) {
        case 'operating_system':
          value = BrowserDetect.os().toLowerCase();
          break;
        case 'browser':
          value = BrowserDetect.browser().toLowerCase();
          break;
        case 'branch_id':
          let branchName = BrowserLocation.uriParams().frontend_tags;

          if (!branchName) break;

          // Leerzeichen werden manchmal als '%20' und manchmal als '+' in den URL Parametern
          // übertragen. Wir ersetzen das `+` Zeichen nun auch in ein valides Leerzeichen.
          branchName = branchName.replace(/\+/g, ' ');
          const filteredOptions = options.for_select.filter((val) => val.title === branchName);

          if (filteredOptions.length) {
            value = filteredOptions[0].value;
          }
          break;
        default:
          break;
      }
    }
    return value;
  }

  function checkAutomatically(options) {
    return (
      options &&
      {}.hasOwnProperty.call(options, 'check_automatically') &&
      options.check_automatically == true
    );
  }

  function radioAutomatically(options, item_value) {
    return (
      options && options.value && options.value.length && item_value === 'Herr' && options.value === 'Mr.'
    );
  }

  return {
    selectAutomatically,
    checkAutomatically,
    radioAutomatically
  };
})();

export default DefautValue;



// WEBPACK FOOTER //
// ./components/forms/defaultValue.js